import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let event_type = useDataValue({
    context: 'automation',
    path: 'event_type',
    viewPath: props.viewPath,
  })
  let action_index = useDataValue({
    context: 'event_action_item',
    path: 'index',
    viewPath: props.viewPath,
  })
  let actions = useDataValue({
    context: 'automation',
    path: 'actions',
    viewPath: props.viewPath,
  })
  let trigger_type = useDataValue({
    context: 'automation',
    path: 'trigger_type',
    viewPath: props.viewPath,
  })
  let automation_type = useDataValue({
    context: 'automation',
    path: 'automation_type',
    viewPath: props.viewPath,
  })
  let new_comms_enabled = useDataValue({
    context: 'global',
    viewPath: props.viewPath,
    path: 'feature_flags.is_automation_hub_comms_enabled',
  })
  let new_tasks_enabled = useDataValue({
    context: 'global',
    viewPath: props.viewPath,
    path: 'feature_flags.is_new_tasks_enabled',
  })

  return useMemo(() => {
    if (!data) return data

    return data
      .map(action =>
        action.id === 'task_insert' && new_tasks_enabled
          ? { ...action, text: 'Create a New Legacy Task' }
          : action
      )
      .filter(action => !action.requires_new_comms_enabled || new_comms_enabled)
      .filter(action => !action.requires_new_tasks_enabled || new_tasks_enabled)
      .filter(
        ({
          supported_event_types,
          supported_automation_types,
          supported_trigger_type,
        }) =>
          supported_event_types.includes(event_type) &&
          (!supported_automation_types ||
            supported_automation_types.includes(automation_type)) &&
          supported_trigger_type.includes(trigger_type)
      )
      .filter(action_type => {
        // check if status_update is used in a different action
        let status_update_used = actions.some(
          (action, index) =>
            action.type === 'status_update' && index !== action_index
        )

        // status_update can only be added once, filter it out if already added on a different action
        return action_type.id !== 'status_update' || !status_update_used
      })
      .sort((a, b) => a.text - b.text)
  }, [
    action_index,
    actions,
    automation_type,
    data,
    event_type,
    new_comms_enabled,
    new_tasks_enabled,
    trigger_type,
  ])
}
